module.exports = __webpack_public_path__ + "img/Miglino.1733cb42.jpg";